import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartFrame from "../../../ChartFrame";

const TicketsPerAgentLineGraph = ({ title, chart }) => {
  return (
    <>
      <ChartFrame height="200px" title={title}>
        <ResponsiveContainer>
          <LineChart
            data={chart}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            isAnimationActive={false}
          >
            <CartesianGrid stroke="#EBEBEB" vertical={false} />
            <XAxis
              dataKey="hour"
              name="Hour"
              axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
            />
            <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} />
            <Tooltip />
            <Legend width="100%" />
            <Line
              type="monotone"
              strokeWidth={3}
              dataKey="total"
              name="Total"
              stroke={"var(--blue)"}
              dot={{ fill: "var(--blue)", r: 2 }}
              activeDot={{ r: 4 }}
              animationDuration={0}
            />
            <Line
              type="monotone"
              strokeWidth={3}
              dataKey="completed"
              name="Completed"
              stroke={"var(--green)"}
              dot={{ fill: "var(--green)", r: 2 }}
              activeDot={{ r: 4 }}
              animationDuration={0}
            />
            <Line
              type="monotone"
              strokeWidth={3}
              dataKey="no_show"
              name="No Show"
              stroke={"var(--red)"}
              dot={{ fill: "var(--red)", r: 2 }}
              activeDot={{ r: 4 }}
              animationDuration={0}
            />
            <Line
              type="monotone"
              strokeWidth={3}
              dataKey="unattended"
              name="Unattended"
              stroke={"var(--orange)"}
              dot={{ fill: "var(--orange)", r: 2 }}
              activeDot={{ r: 4 }}
              animationDuration={0}
            />
          </LineChart>
        </ResponsiveContainer>
      </ChartFrame>
    </>
  );
};

export default TicketsPerAgentLineGraph;
